<template>
    <div class="bt-shop-panel" id="btGoods">
        <div class="shop-panel-top">
            <div class="bt-goods-icon"></div>
            <div class="shop-title ta-l">白条专享好物</div>
            <div class="shop-sub-title ta-l">试试白条支付，优享免息</div>
        </div>
        <div class="shop-panel-body">
            <div class="jdOneThreeColMoreRowNew" data-appid="A309974529837314048"></div>
            <!--  <div class="gold-list">
                  <div class="good-item" v-for="(item,index) in btSkuList" :clstag="item.clstags">
                      <div class="good-item-img">
                          <img class="pct100"
                               :src="'https://m.360buyimg.com/jrqb/s300x300_'+item.itemDetail.image_url">
                      </div>
                      <div class="good-item-name">{{item.itemDetail.ad_title}}</div>
                      <div class="amount-gold">￥{{item.itemDetail.goodsPrice}}</div>
                      <div class="buy-btn" @click="jumpSku(item.itemDetail.click_url)"
                           :clstag="`A05R|clk_baitiaogoods_item_${index+1}`">马上抢
                      </div>
                  </div>
              </div>-->
              <!-- https://mxxq.jd.com/mx/home?from=scpdicon&pageId=2894 -->
            <a class="good-more-link" @click="jumpUrl"
               clstag="A05R|clk_baitiaogoods_more">查看更多商品
                <span class="more-icon"></span></a>
        </div>
    </div>
</template>
<style rel="stylesheet/scss" lang="scss">
    .bt-shop-panel {
        background: #F4F7FE; padding-top: 0.3rem;padding-bottom: 0.3rem; position: relative;z-index: 2;
        .jdOneThreeColMoreRowNew {background-color: #F4F7FE;padding: 0 0.1rem }
        .shop-panel-top {height: 1rem;width: 100%;background: #F4F7FE url(#{$path}/home/shop-panel-top.png) no-repeat center center;background-size: 100% 100%;position: relative;}
        .bt-goods-icon {position: absolute;left: 0.15rem;top: -0.33rem;width: 0.73rem;height: 0.52rem;background: url(#{$path}/shop/bt-goods-icon.png) no-repeat center center;background-size: contain;}
        .shop-title {color: #421C92;font-size: 0.2rem;font-weight: bold;position: absolute;left: 0.15rem;top: 0.3rem;line-height: 1;}
        .shop-sub-title {color: #421C92;font-size: 0.12rem;position: absolute;left: 0.15rem;top: 0.6rem;line-height: 1;}
        .shop-panel-body {background: #F4F7FE;margin-top: -0.05rem;
            .gold-board {width: 3.45rem;height: 0.9rem;background-color: #3450e6;border-radius: 0.08rem;margin: 0 auto;display: flex;justify-content: space-around;align-items: center;color: #fff;}
            .num {font-size: 0.28rem;line-height: 1.1;}
            .text {font-size: 0.12rem;}
            .change-btn {width: 0.91rem;height: 0.46rem;background: url(#{$path}/home/change-btn.png) no-repeat center center;background-size: contain;}
            }
        .gold-list {display: flex;padding: 0 0.15rem; justify-content: space-between;flex-wrap: wrap;}
        .good-item {width: 1.05rem;margin-bottom: 0.2rem;display: flex;flex-direction: column;align-items: flex-start;justify-content: space-between;}
        .good-item-img {width: 1.05rem;height: 1.05rem;background-color: #ccc;border-radius: 0.05rem;overflow: hidden;}
        .good-item-name {display: -webkit-box;text-align: left;color: #333;font-size: 0.12rem;margin-top: 0.05rem; overflow: hidden; text-overflow: ellipsis; display: -webkit-box; -webkit-line-clamp: 3; -webkit-box-orient: vertical;line-height: 0.18rem;height: 0.54rem; word-break: break-all;}
        .amount-gold {text-align: left;font-size: 0.12rem;color: #D85D00;}
        .buy-btn {width: 1.05rem; height: 0.3rem; background: linear-gradient(135deg, rgba(245, 111, 0, 1) 0%, rgba(240, 68, 68, 1) 100%);
            border-radius: 0.2rem;line-height: 0.3rem;font-size: 0.13rem;color: #fff;margin-top: 0.05rem;}
        .good-more-link { display: flex; color: #462C9E; font-size: 0.15rem; font-weight: bold; padding-bottom: 0.2rem;justify-content: center;align-items: center;margin-top: 0.1rem; }
        .more-icon {display: block;width: 0.06rem;height: 0.1rem;background: url(#{$path}/shop/more-icon.png) no-repeat center center; background-size: contain;margin-left: 0.08rem; }
        }
</style>
<script type="javascript">
    import proHub from '../scripts/proHub';
    import Global from '../scripts/Global'

    export default {
        data() {
            return {
                btSkuList: [],
                goodMoreUrl: "https://mxxq.jd.com/mallByStages/home/?from=ttte&pageId=3930", //更多商品推荐的链接
                showbtGoods: false
            }
        },
        computed: {},
        mounted() {
            // window.gylComponent.initJdThreeColMoreRow();
            window.addEventListener('scroll', this.scrollFn, true)
            if (window.data_source_100003725) {
                const { otherConfig = {} } = window.data_source_100003725;
                this.goodMoreUrl = otherConfig && otherConfig.moreGoodUrl;
            }

            /*proHub.get('queryBtGood', {riskDeviceInfo: Global.riskDeviceInfo}, (e) => {
                if (e.code == '0000') {
                    let itemLength = e.data.recommends.length;
                    let sliceLength = Math.min(parseInt(itemLength / 3) * 3, 9);
                    this.btSkuList = e.data.recommends.slice(0, sliceLength);
                }
            })*/
        },
        methods: {
            jumpUrl(){
                this.$jumpUrl(this.goodMoreUrl)
            },
            jumpSku(link) {
                window.location.href = link;
            },
            scrollFn(){
                if(this.showbtGoods){ 
                    window.removeEventListener('scroll', this.scrollFn, true);
                    return false;
                }
                const el = document.getElementById('btGoods')
                if(!el) return false;
                const pos = el.getBoundingClientRect()
                const windowHeight = window.screen.height
                if( pos.y - windowHeight > 500) return false;
                if(this.showbtGoods) return false;
                this.getBtGoodsData()
                this.showbtGoods = true
                window.removeEventListener('scroll', this.scrollFn)
            },
            getBtGoodsData() {
                let _this = this;
                const script1 = document.createElement("script");
                script1.src = "//jddx.jd.com/m/outputjs/newbundle.js?from=A309974529837314048";
                script1.async = false;
                script1.onload = function () {
                    try {
                        window.gylComponent && window.gylComponent.initJdThreeColMoreRow();
                    } catch (error) {
                        throw new Error(error);
                    }
                };
                document.head.append(script1);
            }
        }
    }
</script>
